import { UploadOutlined } from '@ant-design/icons'
import { useQueryClient } from '@tanstack/react-query'
import { Button, message, Upload } from 'antd'

import { AppAdmin } from 'api/app-admin'
import ButtonDownload from 'component/button/button-download'
import { ALLOWED_MIME_TYPES_EXCEL } from 'constants/mime-type'
import useUploadFile from 'hooks/use-upload-file'
import { logError } from 'utils/logger'

import WhitelistHistory, { PTO_WHITELIST_HISTORY_QUERY_KEY } from './whitelist-history'

const ButtonUploadWhitelist = ({
  id,
  edit = true,
}: {
  id?: string | null | undefined
  edit?: boolean
}) => {
  const queryClient = useQueryClient()
  const { singleFile, handleUploadSingle, beforeUploadSingle } = useUploadFile({
    mimeTypes: ALLOWED_MIME_TYPES_EXCEL,
    onUpload: async (file) => {
      const formData = new FormData()
      formData.append('file', file)
      try {
        if (!id) return
        const response = await AppAdmin.uploadWhitelistPTO(id, formData)
        if (response.data.success) {
          message.success('File uploaded successfully')
          queryClient.invalidateQueries({ queryKey: [PTO_WHITELIST_HISTORY_QUERY_KEY, id] })
        }
      } catch (error: any) {
        message.error(error?.message || 'File upload failed')
        logError('Upload error:', error)
      }
    },
    onBeforeUpload: () => {
      message.error('Mime type not allowed')
      return false
    },
  })

  return (
    <>
      <Upload
        disabled={!edit}
        fileList={singleFile}
        customRequest={handleUploadSingle}
        beforeUpload={beforeUploadSingle}
        accept={ALLOWED_MIME_TYPES_EXCEL.join(',').toString()}
      >
        <Button type="default" htmlType="button" icon={<UploadOutlined />}>
          Upload Whitelist
        </Button>
      </Upload>
      <p className="text-12">You can only upload XLSX/CSV file.</p>
      <ButtonDownload
        fileUrl={'/whilelist_tokenize.csv'}
        text="Download sample file"
        className="text-12"
        disabled={!edit}
        style={{
          display: 'inline-block',
          color: '#2b79f7',
          textDecoration: 'underline',
          cursor: 'pointer',
          marginTop: 0,
        }}
      />
      <WhitelistHistory id={id} />
    </>
  )
}

export default ButtonUploadWhitelist
